/**
 * Decode a JWT payload WITHOUT verifying the signature.
 * UI-only (read display claims / detect impersonation) — never trust for authorization.
 */
export function decodeJwtPayload(token: string): Record<string, any> | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}
